import { IUser, IUserPolicies } from '@packlink/packlink-sdk';
import { IAppState } from '@store/reducers';

export const getUser = (state: IAppState): IUser => {
    if (!state.user) {
        throw new Error('User is not set');
    }
    return state.user;
};

export const getUserPolicies = (state: IAppState): IUserPolicies | undefined => getUser(state).policies;

export const hasUserAcceptedTermsAndConditions = (state: IAppState): boolean =>
    !!getUserPolicies(state)?.termsAndConditions;
